import { useEffect, useRef, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useInventorySync } from "../../api/hooks";
import { Footer } from "./Footer";
import { Header } from "./Header";
import styles from "./Layout.module.css";
import { TopBar } from "./TopBar";

export function Layout({ children }: { children: ReactNode }) {
  useInventorySync();
  const { pathname } = useLocation();
  // Only on navigating: a page's first load keeps the browser's position, as a pre-rendered page can be
  // scrolled before this runs. Block body: Chromium's scrollTo() returns a Promise, which useEffect would
  // treat as a cleanup.
  const scrolledFor = useRef(pathname);
  useEffect(() => {
    if (scrolledFor.current === pathname) return;
    scrolledFor.current = pathname;
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={styles.shell}>
      <a href="#main" className={styles.skipLink}>
        Skip to content
      </a>
      <TopBar />
      <Header />
      <main id="main" className={styles.main}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
